import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SuporteLayout from "../components/SuporteLayout";

const SuportePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Suporte" />
        <SuporteLayout />
      </MasterLayout>
    </>
  );
};

export default SuportePage;
